import { Injectable } from '@angular/core';
import {HttpClient, HttpParams} from '@angular/common/http';
import {environment} from '../../../environments/environment';
import {Helper} from '../../helpers/helper.service';
import {Observable} from 'rxjs';
import {DomainListResponse, DomainResponse, SortingModel} from '../translation.models';

@Injectable({
  providedIn: 'root'
})
export class DomainService {
  /**
   * @param helper
   * @param {HttpClient} http
   */
  constructor(private helper: Helper, private http: HttpClient) {}

  /**
   * List domains
   *
   * @param params
   * @returns {Observable<DomainListResponse>}
   */
  public list(params = new HttpParams()): Observable<DomainListResponse> {
    const url = `${environment.apiUrl}/translation/domain/`;
    return this.http.get<DomainListResponse>(
      url,
      {params: params}
    );
  }

  /**
   * Find a domain by given name
   * @param {string} name
   * @returns {Observable<Object>}
   */
  public getByName(name: string) {
    return this.http.get<DomainResponse>(
      `${environment.apiUrl}/translation/domain/${name}`
    );
  }
}
